@if(error()) {
<div class="error">{{ error() }}</div>
}

@if(autoProcessing()) {
<div class="processing-container d-flex flex-column align-items-center justify-content-center" style="min-height: 300px;">
  <div class="spinner-border text-primary" role="status"></div>
  <p class="mt-3 text-muted">Setting up your subscription...</p>
</div>
} @else {
<div class="pricing-container" [busyCover]="busy()">
  @if(hasPaidPlans()) {
  <div class="pricing-toggle">
    <span [class.active]="!isAnnual()" (click)="isAnnual.set(false)">Monthly</span>
    <button class="toggle-button" (click)="toggleInterval()">
      <div class="toggle-slider" [class.annual]="isAnnual()"></div>
    </button>
    <span [class.active]="isAnnual()" (click)="isAnnual.set(true)">Annual</span>
  </div>
  }

  <div class="pricing-grid">
    @for(tier of pricingTiers(); track tier.name) {
    <div
      class="pricing-card"
      [class.subscribed]="tier.subscribed"
      [class.coming-soon]="tier.comingSoon"
    >
      @if(tier.comingSoon) {
      <div class="coming-soon-badge">Coming Soon</div>
      }
      <div class="tier-header">
        <h3>{{ tier.name }}</h3>
      </div>

      <div class="price-section">
        <div class="price">
          <span class="currency">{{ getCurrency(tier) | uppercase }}</span>
          <span class="amount">{{ getPrice(tier) }}</span>
          <span class="period">/{{ isAnnual() ? "year" : "month" }}</span>
        </div>
        @if(isAnnual() && tier.monthly && tier.annual) {
        <div class="savings">
          Save
          {{ (tier.monthly.price) * 12 - (tier.annual.price) | currency }}
          per year
        </div>
        }
        @if(!tier.subscribed && isTrialEligible()) {
        <div class="trial-info">14-day free trial</div>
        }
      </div>

      <button
        class="subscribe-button"
        (click)="subscribeTo(tier)"
        [disabled]="tier.comingSoon"
      >
        {{
          tier.comingSoon
            ? "Coming Soon"
            : tier.subscribed
            ? "Current Plan"
            : isTrialEligible()
            ? "Start Free Trial"
            : "Subscribe"
        }}
      </button>
    </div>
    }
  </div>

</div>
}
